import React from "react";
import { cn } from "utils";
import { NextImage } from "@/src/components/NextImage";

export interface TopPerformerLeftContentProps {
  /** 代币符号 */
  symbol: string;
  /** 代币图标 URL */
  icon?: string;
  /** 自定义类名 */
  className?: string;
}

/**
 * Top Performer 统计的左侧内容组件
 * 显示代币图标和符号
 */
export const TopPerformerLeftContent: React.FC<
  TopPerformerLeftContentProps
> = ({ symbol, icon, className }) => {
  return (
    <div className={cn("flex gap-2 items-center shrink-0", className)}>
      {/* 代币图标 */}
      {icon && (
        <div className="relative shrink-0 size-8 rounded-full border border-solid border-border_solid overflow-clip">
          <NextImage
            src={icon}
            alt={symbol}
            width={32}
            height={32}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      {/* 代币符号 */}
      <p className="headline_regular_m text-content_primary">{symbol}</p>
    </div>
  );
};
